export default "/wp-content/themes/oportun/dist/assets/brand/logo_color-f261b03e95f7d180.svg"